import Tooltip from './src/tooltip.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToTooltip: SFCWithInstall<typeof Tooltip> = withInstall(Tooltip)

export * from './src/instance'
